 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"404":"404","sale_dashboard":"sale_dashboard","activity_log":"activity_log","books_general":"books_general","books_police":"books_police","books_weapons":"books_weapons","invoices":"invoices","contact_edit":"contact_edit","inventory_edit":"inventory_edit","requisition_edit":"requisition_edit","sale_edit":"sale_edit","contact_create":"contact_create","inventory_create":"inventory_create","invoice_create~invoice_edit":"invoice_create~invoice_edit","invoice_create":"invoice_create","invoice_edit":"invoice_edit","requisition_create":"requisition_create","stocks":"stocks","dashboard":"dashboard","client":"client","config":"config","contacts":"contacts","inventories":"inventories","product_create~product_edit":"product_create~product_edit","product_create":"product_create","product_edit":"product_edit","products":"products","requisitions":"requisitions","sales_book":"sales_book","statistics":"statistics","structure~user":"structure~user","structure":"structure","user":"user","template":"template","trash":"trash","video":"video","legal":"legal","login":"login","passwordReset":"passwordReset","passwordUpdate":"passwordUpdate","pay":"pay","payment-check":"payment-check"}[chunkId]||chunkId) + "." + {"404":"4956b816","chunk-ccaea758":"359ed1d6","chunk-7b1e2a45":"ff18fcac","sale_dashboard":"93fe4730","chunk-f569a260":"7c826a51","activity_log":"d6533d3c","chunk-46c14786":"05572d15","chunk-4f934cfe":"894ac385","books_general":"951be54f","books_police":"64462cc8","books_weapons":"9733cf13","chunk-17dcd48c":"2d3654ee","chunk-b688bf34":"927a2c01","invoices":"fac1523f","chunk-268efbf8":"c7658556","chunk-45268516":"6ea64062","chunk-efe065c0":"d743d0cd","chunk-f090ec90":"2cd92513","contact_edit":"8d9e008a","inventory_edit":"ae7fc3a1","requisition_edit":"f0200178","sale_edit":"7d335e73","contact_create":"efe009ef","inventory_create":"e93affea","invoice_create~invoice_edit":"798670a6","invoice_create":"ef7dace1","invoice_edit":"bf1031cb","requisition_create":"28a292cc","stocks":"35a83405","dashboard":"f9d2c4e2","client":"51556aa4","config":"889f4a03","contacts":"5ac5309c","inventories":"01b3b924","product_create~product_edit":"1cef5af2","product_create":"cb13a3dc","product_edit":"9fad6a10","products":"a970f568","requisitions":"ea19cf4e","sales_book":"516fb2f0","statistics":"b8691531","structure~user":"59c15d4b","structure":"518fc3a2","user":"bccadc6b","template":"4df3302f","trash":"9402669e","video":"471b6f66","legal":"0fb9a0c5","login":"df4535b0","passwordReset":"9339581e","passwordUpdate":"f45adbca","pay":"e0c0fc61","payment-check":"8c1ddded"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"404":1,"chunk-7b1e2a45":1,"sale_dashboard":1,"chunk-f569a260":1,"activity_log":1,"chunk-46c14786":1,"chunk-4f934cfe":1,"books_general":1,"books_police":1,"books_weapons":1,"chunk-17dcd48c":1,"chunk-b688bf34":1,"invoices":1,"chunk-268efbf8":1,"chunk-45268516":1,"chunk-efe065c0":1,"chunk-f090ec90":1,"contact_edit":1,"inventory_edit":1,"requisition_edit":1,"sale_edit":1,"inventory_create":1,"invoice_create~invoice_edit":1,"requisition_create":1,"stocks":1,"dashboard":1,"client":1,"config":1,"contacts":1,"inventories":1,"product_create~product_edit":1,"products":1,"requisitions":1,"sales_book":1,"statistics":1,"structure~user":1,"structure":1,"user":1,"template":1,"trash":1,"video":1,"legal":1,"login":1,"passwordReset":1,"passwordUpdate":1,"pay":1,"payment-check":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"404":"404","sale_dashboard":"sale_dashboard","activity_log":"activity_log","books_general":"books_general","books_police":"books_police","books_weapons":"books_weapons","invoices":"invoices","contact_edit":"contact_edit","inventory_edit":"inventory_edit","requisition_edit":"requisition_edit","sale_edit":"sale_edit","contact_create":"contact_create","inventory_create":"inventory_create","invoice_create~invoice_edit":"invoice_create~invoice_edit","invoice_create":"invoice_create","invoice_edit":"invoice_edit","requisition_create":"requisition_create","stocks":"stocks","dashboard":"dashboard","client":"client","config":"config","contacts":"contacts","inventories":"inventories","product_create~product_edit":"product_create~product_edit","product_create":"product_create","product_edit":"product_edit","products":"products","requisitions":"requisitions","sales_book":"sales_book","statistics":"statistics","structure~user":"structure~user","structure":"structure","user":"user","template":"template","trash":"trash","video":"video","legal":"legal","login":"login","passwordReset":"passwordReset","passwordUpdate":"passwordUpdate","pay":"pay","payment-check":"payment-check"}[chunkId]||chunkId) + "." + {"404":"9591514b","chunk-ccaea758":"31d6cfe0","chunk-7b1e2a45":"2b6a5a89","sale_dashboard":"3260b6ce","chunk-f569a260":"b2f3b260","activity_log":"4eaeb704","chunk-46c14786":"24cb7da1","chunk-4f934cfe":"f9f70877","books_general":"4edcffdc","books_police":"4edcffdc","books_weapons":"4edcffdc","chunk-17dcd48c":"af8e735f","chunk-b688bf34":"f56c51d3","invoices":"2f8e2197","chunk-268efbf8":"2e6b74df","chunk-45268516":"2174f82c","chunk-efe065c0":"628bad89","chunk-f090ec90":"048ef9cd","contact_edit":"be2c2761","inventory_edit":"16e1e046","requisition_edit":"7e01214b","sale_edit":"4bdc16ce","contact_create":"31d6cfe0","inventory_create":"6afe7b05","invoice_create~invoice_edit":"0fd16cba","invoice_create":"31d6cfe0","invoice_edit":"31d6cfe0","requisition_create":"99e60807","stocks":"80f580a3","dashboard":"9faaa282","client":"388ef67c","config":"8d5f3f7c","contacts":"b9c617e7","inventories":"1a803846","product_create~product_edit":"0f85f705","product_create":"31d6cfe0","product_edit":"31d6cfe0","products":"3fc09061","requisitions":"96c0f540","sales_book":"7172ef50","statistics":"2a9f19cc","structure~user":"99f4a6ba","structure":"a6cfd588","user":"7777c5fe","template":"50057651","trash":"bc92147d","video":"efe6619a","legal":"3a4c4db9","login":"836f97fe","passwordReset":"84dd5c95","passwordUpdate":"aa6dd07a","pay":"45a5c699","payment-check":"44a56fd4"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
